import React, { useState, useEffect } from "react";
import Select from "components/shared/Select";
import { components } from "react-select";

const selectInputTextPrefix = {
  sm: "Title starts with: ",
  xs: "Title starts: "
};

const GuideListAlphabeticalFilterControl = (props) => {
  const filterOptions = Object.values(props.baseFilterOptions)
    .concat("ABCDEFGHIJKLMNOPQRSTUVWXYZ".split(""))
    .map((k) => {
      return { label: k, value: k };
    });

  const [selectedFilterOption, setSelectedFilterOption] = useState(
    props.defaultFilterOption
  );

  // changes to query params will be passed downstream to this component
  useEffect(() => {
    if (
      props.queryParamOptions &&
      props.queryParamOptions.filterOption !== selectedFilterOption
    ) {
      const filterOptionFromQP =
        props.queryParamOptions.filterOption || props.baseFilterOptions.all;
      setSelectedFilterOption(filterOptionFromQP);
      props.onSetFilterOption(filterOptionFromQP, false);
    }
  }, [props.queryParamOptions]);

  const handleChange = (option) => {
    setSelectedFilterOption(option.value);
    props.onSetFilterOption(option.value);
  };

  return (
    <div className="guide-list__control guide-list__control--filter">
      <Select
        options={filterOptions}
        baseClassName="lc-select-container--md"
        containerClassName="select-container guide-list__control-select--xxs"
        value={selectedFilterOption}
        isControlled
        name="guide-list__filter-select"
        onChange={(option) => handleChange(option)}
        labelText="Title starts with"
      />
      <Select
        options={filterOptions}
        baseClassName="lc-select-container--md"
        containerClassName="select-container guide-list__control-select--xs"
        value={selectedFilterOption}
        isControlled
        name="guide-list__filter-select"
        onChange={(option) => handleChange(option)}
        components={{
          /* eslint-disable react/no-unstable-nested-components, no-shadow */
          Placeholder: ({ children, ...props }) => {
            return (
              <components.Placeholder {...props}>
                {selectInputTextPrefix.xs + children}
              </components.Placeholder>
            );
          },
          SingleValue: ({ children, ...props }) => {
            return (
              <components.SingleValue {...props}>
                {selectInputTextPrefix.xs + children}
              </components.SingleValue>
            );
          }
          /* eslint-enable react/no-unstable-nested-components, no-shadow */
        }}
      />
      <Select
        options={filterOptions}
        baseClassName="lc-select-container--md"
        containerClassName="select-container guide-list__control-select--sm"
        value={selectedFilterOption}
        isControlled
        name="guide-list__filter-select"
        onChange={(option) => handleChange(option)}
        components={{
          /* eslint-disable react/no-unstable-nested-components, no-shadow */
          Placeholder: ({ children, ...props }) => {
            return (
              <components.Placeholder {...props}>
                {selectInputTextPrefix.sm + children}
              </components.Placeholder>
            );
          },
          SingleValue: ({ children, ...props }) => {
            return (
              <components.SingleValue {...props}>
                {selectInputTextPrefix.sm + children}
              </components.SingleValue>
            );
          }
          /* eslint-enable react/no-unstable-nested-components, no-shadow */
        }}
      />
    </div>
  );
};

export default GuideListAlphabeticalFilterControl;
